
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { EFriend, friends } from '@/types/categories/friend'
import CategoryMedia from '@/components/media/CategoryMedia.vue'

@Component({
  components: {
    CategoryMedia
  }
})
export default class FriendList extends Vue {
  @Prop(Array) friends!: Array<EFriend>
  protected selected: EFriend = EFriend.Alice

  get selectedFriend () {
    return this.$store.getters['selectedFriend']
  }

  protected selectFriend (friend: EFriend) {
    this.selected = friend
    this.$emit('friendClicked', this.selected)
  }
}
